import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
	apiKey: 'AIzaSyCSF0okqn985GkA6uIpvDH0cE3vEoCODUo',
	authDomain: 'ailabapp-com.firebaseapp.com',
	projectId: 'ailabapp-com',
	storageBucket: 'ailabapp-com.appspot.com',
	messagingSenderId: '695915473221',
	appId: '1:695915473221:web:1c85e864e08619820f762c',
	measurementId: 'G-RBN29QSS3K',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };
